import { I18n } from "i18n-js";

/**
 * Note: locales.json is an automatically built from config/locales/en.yml
 *
 * DO NOT MANUALLY EDIT IT.
 *
 * Any changes after a rebuild must be committed to the repository. If you see
 * any local changes, but haven't done anything to en.yml - someone may have
 * forgotten to commit it.
 *
 * It gets rebuilt when:
 *   - You run `bin/dev` locally - Rails watches it and rebuilds on any change.
 *   - You run `bundle exec rails assets:precompile`
 *   - You manually run `bundle exec i18n export`
 *
 * See also:
 *   - https://github.com/fnando/i18n-js - Ruby gem doing the export.
 *   - https://github.com/fnando/i18n - Javascript I18n library providing
 *     similar translation/localisation interface like Ruby I18n.
 */
import translations from "./locales.json";

export const i18n = new I18n(translations);
